import styled, { css } from 'styled-components'

export const Layout = styled.div`
  height: 96.8vh;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f5;

  ${props =>
    props.background &&
    css`
      background-image: url(${props.background});
      background-attachment: fixed;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      @media screen and (max-width: 700px) {
        padding: 2rem 1rem;
      }
    `};

  @media screen and (min-width: 800px) {
    & > div {
      width: 70%;
      max-width: 620px;
    }
  }
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
